import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=1e73ddeb&scoped=true"
import script from "./SupportDialog.vue?vue&type=script&lang=js"
export * from "./SupportDialog.vue?vue&type=script&lang=js"
import style0 from "./SupportDialog.vue?vue&type=style&index=0&id=1e73ddeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e73ddeb",
  null
  
)

export default component.exports